import { render, staticRenderFns } from "./ChatSidebarMessageThread.vue?vue&type=template&id=0307a01e&scoped=true&"
import script from "./ChatSidebarMessageThread.vue?vue&type=script&lang=js&"
export * from "./ChatSidebarMessageThread.vue?vue&type=script&lang=js&"
import style0 from "./ChatSidebarMessageThread.vue?vue&type=style&index=0&id=0307a01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0307a01e",
  null
  
)

export default component.exports